// Privates local storage
const localStorageGetObject = key => JSON.parse(localStorage.getItem(key));
const localStorageSetItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));
const localStorageRemoveItem = key => localStorage.removeItem(key);
// Local Storage
export const lsGetProspectGuid = () => localStorageGetObject('prospect:guid');
export const lsSetProspectGuid = value => localStorageSetItem('prospect:guid', value);
export const lsRemoveProspectGuid = () => {
  localStorageRemoveItem('prospect:guid');
};

export const lsGetAct = () => localStorageGetObject('act');
export const lsSetAct = value => localStorageSetItem('act', value);
export const lsRemoveAct = () => {
  localStorageRemoveItem('act');
};

// TODO [ Para la demo ]
// ----------------------------------------------------------------
export const lsGetAnotherDelivery = () => localStorageGetObject('anotherDelivery');
export const lsSetAnotherDelivery = value => localStorageSetItem('anotherDelivery', value);
export const lsRemoveAnotherDelivery = () => {
  localStorageRemoveItem('anotherDelivery');
};

export const lsGetKmCount = () => localStorageGetObject('kmCount');
export const lsSetKmCount = value => localStorageSetItem('kmCount', value);
export const lsRemoveKmCount = () => {
  localStorageRemoveItem('kmCount');
};

export const lsGetExternalBreaks = () => localStorageGetObject('externalBreaks');
export const lsSetExternalBreaks = value => localStorageSetItem('externalBreaks', value);
export const lsRemoveExternalBreaks = () => {
  localStorageRemoveItem('externalBreaks');
};
// ----------------------------------------------------------------
